import React from 'react';
import { Accordion, Grid, Progress, Card, Button } from 'semantic-ui-react';
import classNames from 'classnames';

const STATUS_STARTING = 0;
const STATUS_INFO = 1;
const STATUS_SUCCESS = 2;
const STATUS_ERROR = 3;
const STATUSES = {
  [STATUS_STARTING]: 'starting',
  [STATUS_INFO]: 'info',
  [STATUS_SUCCESS]: 'success',
  [STATUS_ERROR]: 'error',
};

const MessageCard = ({
  title,
  description,
  status,
  source,
  data,
  cancelProcess,
}) => (
  <Card
    datasource={source}
    className={`app-center-progress--message--status-${STATUSES[status]}`}
    fluid={true}
  >
    <Card.Content>
      {title && <Card.Header>{title}</Card.Header>}
      {description && <Card.Description>{description}</Card.Description>}
      {data &&
        data.Percentage && (
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column width={14} verticalAlign={'middle'}>
                <Progress progress={'percent'} percent={data.Percentage} />
              </Grid.Column>
              <Grid.Column width={2} verticalAlign={'middle'}>
                <Button
                  circular
                  color="orange"
                  icon="close"
                  onClick={cancelProcess}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
    </Card.Content>
  </Card>
);
const SignalRCenterProgressComponent = ({
  display,
  hideCenterMessages,
  showCenterMessages,
  removeCenterMessage,
  deactivateCenterMessages,
  payload = [],
  cancelProcess,
}) => {
  if (payload.length === 0) return null;

  const toggleAction = display ? hideCenterMessages : showCenterMessages;

  let shouldDeactivate = true;
  let shouldShow = true;
  payload.forEach(msg => {
    if (msg.Status !== STATUS_STARTING) {
      shouldShow = false;
    }
    if (msg.Status !== STATUS_SUCCESS && msg.Status !== STATUS_ERROR) {
      shouldDeactivate = false;
    } else {
      setTimeout(() => removeCenterMessage(msg.Id), 2000);
    }
  });

  if (shouldDeactivate) {
    setTimeout(() => deactivateCenterMessages(), 2000);
  }

  if (shouldShow) {
    setTimeout(() => showCenterMessages(), 2000);
  }
  const isActive = classNames(
    'app-center-progress--messages--display-trigger',
    { active: display }
  );
  return (
    <div className={'loading--wrapper'}>
      <div className="loading--content">
        <div className={'app-center-progress--wrapper'}>
          <Accordion>
            <Accordion.Title
              onClick={() => toggleAction()}
              className={isActive}
            >
              <div className="app-center-progress--title-label">
                Work In Progress
              </div>
              {payload.length > 0 ? (
                <span className="app-center-progress--messages-count pull-right">
                  {payload.length}
                </span>
              ) : (
                undefined
              )}
            </Accordion.Title>
            <Accordion.Content active={display}>
              <div className="app-center-progress--messages-content">
                <Grid container>
                  {!display
                    ? null
                    : payload.map(msg => (
                        <Grid.Row columns={1} key={msg.Id}>
                          <Grid.Column>
                            <MessageCard
                              source={msg.Source}
                              title={msg.Message.Title}
                              description={msg.Message.Description}
                              status={msg.Status}
                              data={msg.Data}
                              cancelProcess={cancelProcess}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      ))}
                </Grid>
              </div>
            </Accordion.Content>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default SignalRCenterProgressComponent;



// WEBPACK FOOTER //
// ./src/components/signalRCenterProgress/component/index.js